import { fieldHasValue } from 'modules/Inquiry/Form/formConditions';
import { PURPOSE_KIND, PURPOSE_KIND__VEHICLE } from 'modules/Inquiry/Form/formFields';

export const purposeConditions = {
  hasVehiclePurpose: fieldHasValue(PURPOSE_KIND, PURPOSE_KIND__VEHICLE),
  hasMachinePurpose: fieldHasValue(PURPOSE_KIND, PURPOSE_KIND__VEHICLE),
};
